module.exports = __webpack_public_path__ + "static/media/axe-3.90693678.glb";